export const PENDING_DETAILS = "PENDING_DETAILS";
export const REGISTERED = "REGISTERED";
export const PROCESSING = "PROCESSING";
export const IN_REVIEW = "IN_REVIEW";

export const MONTHLY = "MONTHLY";
export const QUARTERLY = "QUARTERLY";
export const ANNUALLY = "ANNUALLY";
export const SEMI_ANNUALLY = "SEMI_ANNUALLY";
export const NONE = "NONE";
